import React from "react";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";

const ItemWrapper = (props) => {
  return (
    <div className="currency_container">
      <Fade>
        <div {...props} className="bts-sales-category my-3">
          <div>
            <img src={props.img} height="120px" alt="" className="bannerstyle" />
            <div className="d-flex justify-content-between mt-3">
              <span className="b7">{props.name}</span>
              <span>
                {props.available === "false" ? (
                  <span
                    // to={`/guest/buy/${props.id}`}
                    className="bts-sales-button lightBlue smallText"
                  >
                    Buy
                  </span>
                ) : (
                  <span className="bts-sales-button lightBlue smallText">
                    Buy
                  </span>
                )}
                {props.available === "false" ? (
                  <Link
                    to={`/guest/sell/${props.id}`}
                    className="bts-sales-button blueText"
                  >
                    Sell
                  </Link>
                ) : (
                  <span className="bts-sales-button blueText">Sell</span>
                )}
              </span>
            </div>
            {/* <section className="mt-3 b4">
                We Buy @ ₦{props.brate}/$
            </section> */}
             <section className="mt-3 b4">
                We Sell (Coming soon)
            </section>
            <span className="smallText lightBlue b5">
              We Buy ₦{props.srate}/$
            </span>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default ItemWrapper;
